import { render, staticRenderFns } from "./store_review.vue?vue&type=template&id=be1e8f4e&scoped=true&"
import script from "./store_review.vue?vue&type=script&lang=js&"
export * from "./store_review.vue?vue&type=script&lang=js&"
import style0 from "./store_review.vue?vue&type=style&index=0&id=be1e8f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1e8f4e",
  null
  
)

export default component.exports